/**
 * Constantes compartidas de la aplicación
 */

// Colecciones de Firebase
export const COLLECTIONS = {
  PRODUCTOS: 'Productos',
  PEDIDOS: 'Pedidos',
};

// Rutas de la aplicación
export const ROUTES = {
  HOME: '/',
  CAJAS: '/cajas',
  EMBALAJE: '/embalaje',
  AUTOARMABLES: '/autoarmables',
  // Alias legacy (API sigue usando estos valores de categoría)
  FUNDAS: '/cajas',
  ACCESORIOS: '/embalaje',
  VIDRIOS: '/autoarmables',
  CARRITO: '/carrito',
  COMPRA_EXITOSA: '/compra-exitosa',
  PEDIDO_REGISTRADO: '/pedido-registrado',
  CHECKOUT_FAILURE: '/checkout/failure',
  CHECKOUT_PENDING: '/checkout/pending',
  LOGIN: '/login',
  ADMIN: '/admin',
  ADMIN_PRODUCTOS: '/admin/productos',
  ADMIN_CATEGORIAS: '/admin/categorias',
  ADMIN_PEDIDOS: '/pedidos',
  TERMINOS: '/terminos-y-condiciones',
  CONTACTO: '/contacto',
};

/**
 * Categorías de productos
 * - `api`: valor que espera el backend (no cambiar sin migrar API/DB)
 * - `visible`: controla qué se muestra en nav / home (preparado para futuras categorías)
 */
export const CATEGORIAS = {
  FUNDAS: 'fundas',
  ACCESORIOS: 'accesorios',
  VIDRIOS: 'vidrios',
};

export const CATEGORIA_UI = {
  fundas: {
    api: 'fundas',
    path: '/cajas',
    label: 'Cajas',
    shortLabel: 'Cajas',
    navLabel: 'Cajas',
    description: 'Standard, borceguí, botín y archivo cofre — precio único por medida',
    filtroModelo: 'Medida',
    filtroMaterial: 'Categoría',
    filtroColor: 'Color',
    icon: 'box',
    visible: true,
  },
  // Preparadas para activar sin migrar API (visible: false por ahora)
  accesorios: {
    api: 'accesorios',
    path: '/embalaje',
    label: 'Embalajes',
    shortLabel: 'Embalajes',
    navLabel: 'Embalajes',
    description: 'Insumos y protección para tus envíos',
    filtroModelo: 'Medida',
    filtroMaterial: 'Material',
    filtroColor: 'Color',
    filtroCategoria: 'Tipo de insumo',
    icon: 'tape',
    visible: false,
  },
  vidrios: {
    api: 'vidrios',
    path: '/autoarmables',
    label: 'Cajas Microcorrugadas',
    shortLabel: 'Microcorrugadas',
    navLabel: 'Microcorrugadas',
    description: 'Microcorrugado ideal para retail y e-commerce',
    filtroModelo: 'Medida',
    filtroMaterial: 'Tipo',
    filtroColor: 'Color',
    icon: 'package',
    visible: false,
  },
};

/** Categorías internas de cajas (se guardan en `material`) */
export const CAJAS_TIPOS = [
  { value: 'standard', label: 'Standard' },
  { value: 'borcegui', label: 'Borceguí' },
  { value: 'botin', label: 'Botín' },
  { value: 'archivo cofre', label: 'Archivo cofre' },
];

export const labelCajaTipo = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  const key = raw.toLowerCase();
  const found = CAJAS_TIPOS.find(
    (t) => t.value === key || t.label.toLowerCase() === key
  );
  if (found) return found.label;
  // Primera letra mayúscula; el resto en minúsculas
  return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
};

/** Categorías visibles en nav / home (hoy solo Cajas Corrugadas) */
export const NAV_CATEGORIES = Object.values(CATEGORIA_UI).filter((c) => c.visible);

/** Todas las categorías (admin / rutas internas) */
export const ALL_CATEGORIES = Object.values(CATEGORIA_UI);

/** Resuelve path de catálogo según categoría API */
export const pathPorCategoriaApi = (categoria) => {
  const key = (categoria || '').toString().toLowerCase();
  return CATEGORIA_UI[key]?.path || ROUTES.CAJAS;
};

/** Etiqueta UI para categoría API (`fundas` → `Cajas`, etc.) */
export const labelCategoriaApi = (categoria) => {
  const key = (categoria || '').toString().toLowerCase().trim();
  if (!key) return '';
  return CATEGORIA_UI[key]?.label || categoria;
};

export const BRAND = {
  NAME: 'Cajas Amanecer',
  TAGLINE: 'Fábrica de cajas corrugadas',
  INSTAGRAM: 'https://www.instagram.com/',
  FACEBOOK: 'https://www.facebook.com/',
  EMAIL: 'ventas@cajasamanecer.com',
  CUIT: 'XX-XXXXXXXX-X',
};

// Estados de pedidos
export const ESTADOS_PEDIDO = {
  CREADO: 'CREADO',
  PENDIENTE: 'PENDIENTE',
  EN_PROCESO: 'EN_PROCESO',
  COMPLETADO: 'COMPLETADO',
  CANCELADO: 'CANCELADO',
};

// Configuración de contacto
export const CONTACTO = {
  WHATSAPP_NUMERO: 'x',
  WHATSAPP_DISPLAY: 'x',
};

export const presupuestoWhatsAppUrl = (mensaje) =>
  `https://wa.me/${CONTACTO.WHATSAPP_NUMERO}?text=${encodeURIComponent(
    mensaje || 'Hola, quiero solicitar un presupuesto de cajas corrugadas.'
  )}`;

// Storage keys
export const STORAGE_KEYS = {
  CARRITO: 'carrito',
  JWT_TOKEN: 'icase_jwt_token',
  MP_CHECKOUT_PEDIDO_ID: 'mp_checkout_pedido_id',
  WHATSAPP_PEDIDO_PREFIX: 'whatsapp_pedido_',
};

export const DESTACADOS_MAX = 8;
export const DESTACADOS_MIN = 4;
